Vue.component('ack-curie-resin-library', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-curie-resin-library',
	mixins: [languageMixins],
	created() {},
	mounted() {
		this.setPageIsLoading(false);
		const script = document.createElement('script');
		script.src = 'https://js.hsforms.net/forms/v2.js';
		document.body.appendChild(script);
	},
	props: {
		// dataIn: {
		//   type: Object,
		//   required: true
		// }
	},
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		//...Vuex.mapGetters('articles', ['articlesArray']),
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			pageId: 'curie-resin-library-page',
			searchTerms: null,
			v1ShowInfo: false,
			v2ShowInfo: false,
			notFoundShowInfo: false,
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions('sliders', ['getSlideList'])
		showV1Form() {
			this.v1ShowInfo = true;
			this.v2ShowInfo = false;
			if (window.hbspt) {
				window.hbspt.forms.create({
					region: 'na1',
					portalId: '2471334',
					formId: 'c1afe7cf-06d9-4275-b292-ceca9052b7c9',
					target: '#curie-v1',
				});
			}
		},
		showV2Form() {
			this.v1ShowInfo = false;
			this.v2ShowInfo = true;
			this.notFoundShowInfo = false;
			if (window.hbspt) {
				window.hbspt.forms.create({
					region: 'na1',
					portalId: '2471334',
					formId: 'fcdf52ee-a292-4379-a77f-de6d01809653',
					target: '#curie-v2',
				});
			}
		},
		showNoForm() {
			this.v1ShowInfo = false;
			this.v2ShowInfo = false;
			this.notFoundShowInfo = true;
		},
		showFormBaseOnFirstLetter(firstLetter) {
			const serialAndFormTypes = {
				B: 'v1',
				C: 'v2',
				D: 'v2',
				E: 'v2',
				F: 'v2',
				G: 'v2',
			};
			const formType = serialAndFormTypes[firstLetter];
			if (formType === 'v1') {
				return this.showV1Form();
			}
			if (formType === 'v2') {
				return this.showV2Form();
			}
			if (formType === undefined) {
				return this.showNoForm();
			}
		},
		search() {
			let firstLetterToUpper = this.searchTerms.toUpperCase()[0];
			// show form base on first serial letter
			this.showFormBaseOnFirstLetter(firstLetterToUpper);
		},
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
